import { API_BASE_URL } from '../config/api';

export interface DisconnectionRequest {
  id: string;
  clientId: string;
  clientName: string;
  dietitianId: string;
  dietitianName: string;
  requestedBy: 'Client' | 'Dietitian';
  status: 'Pending' | 'Approved' | 'Rejected' | 'AutoApproved';
  reason?: string;
  responseMessage?: string;
  createdAt: string;
  respondedAt?: string;
  autoApproveAt: string;
}

export interface CreateDisconnectionRequestRequest {
  clientId: string;
  dietitianId: string;
  requestedBy: 'Client' | 'Dietitian';
  reason?: string;
}

export interface ApproveDisconnectionRequest {
  responseMessage?: string;
}

export interface RejectDisconnectionRequest {
  responseMessage?: string;
}

export const disconnectionRequestApi = {
  async createDisconnectionRequest(
    request: CreateDisconnectionRequestRequest
  ): Promise<DisconnectionRequest> {
    const response = await fetch(`${API_BASE_URL}/disconnectionrequests`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Ayrılma isteği oluşturulamadı');
    }
    return await response.json();
  },

  async getDisconnectionRequest(id: string): Promise<DisconnectionRequest> {
    const response = await fetch(`${API_BASE_URL}/disconnectionrequests/${id}`);
    if (!response.ok) {
      throw new Error('Ayrılma isteği getirilemedi');
    }
    return await response.json();
  },

  async getDisconnectionRequestsByClient(clientId: string): Promise<DisconnectionRequest[]> {
    const response = await fetch(
      `${API_BASE_URL}/disconnectionrequests/client/${clientId}`
    );
    if (!response.ok) {
      throw new Error('Ayrılma istekleri getirilemedi');
    }
    return await response.json();
  },

  async getDisconnectionRequestsByDietitian(dietitianId: string): Promise<DisconnectionRequest[]> {
    const response = await fetch(
      `${API_BASE_URL}/disconnectionrequests/dietitian/${dietitianId}`
    );
    if (!response.ok) {
      throw new Error('Ayrılma istekleri getirilemedi');
    }
    return await response.json();
  },

  async getPendingDisconnectionRequest(
    clientId: string,
    dietitianId: string
  ): Promise<DisconnectionRequest | null> {
    const response = await fetch(
      `${API_BASE_URL}/disconnectionrequests/pending/client/${clientId}/dietitian/${dietitianId}`
    );
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('Bekleyen ayrılma isteği getirilemedi');
    }
    return await response.json();
  },

  async approveDisconnectionRequest(
    id: string,
    request: ApproveDisconnectionRequest
  ): Promise<DisconnectionRequest> {
    const response = await fetch(`${API_BASE_URL}/disconnectionrequests/${id}/approve`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Ayrılma isteği onaylanamadı');
    }
    return await response.json();
  },

  async rejectDisconnectionRequest(
    id: string,
    request: RejectDisconnectionRequest
  ): Promise<DisconnectionRequest> {
    const response = await fetch(`${API_BASE_URL}/disconnectionrequests/${id}/reject`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Ayrılma isteği reddedilemedi');
    }
    return await response.json();
  },
};

